import { render, staticRenderFns } from "./tmbMsi.vue?vue&type=template&id=56ad769c&scoped=true"
import script from "./tmbMsi.vue?vue&type=script&lang=js"
export * from "./tmbMsi.vue?vue&type=script&lang=js"
import style0 from "./tmbMsi.vue?vue&type=style&index=0&id=56ad769c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ad769c",
  null
  
)

export default component.exports